/*
  biberna - Mindestbestellwert-Hinweis fuer den Newsletter-Code im Drawer.
  Markup: snippets/biberna-cart-mbw.liquid. Hintergrund dort im Kopf.

  Zeigt "Noch X EUR bis dein 25 %-Code gilt", wenn
    - ein Code mit Praefix "welcome-to-biberna" im Warenkorb liegt,
    - Shopify ihn als nicht anwendbar fuehrt (applicable: false) und
    - die Zwischensumme der Artikel unter 100 EUR liegt.
  Sobald der Code greift oder entfernt wird, verschwindet der Hinweis.

  Quelle ist /cart.js. Der Block liegt im Swap-Bereich des Drawers und
  wird bei jeder Aenderung neu gerendert - deshalb wird nach jedem
  Cart-Request und jeder DOM-Aenderung im Drawer erneut gemalt. paint()
  schreibt nur, wenn sich etwas aendert, sonst liefe der Observer im Kreis.
*/
(function () {
  var THRESHOLD = 10000; /* Cent */
  var PREFIX = /^welcome-to-biberna/i;
  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var state = { show: false, missing: 0 };

  function paint() {
    var el = document.querySelector('[data-bib-mbw]');
    if (!el) return;
    if (!state.show) {
      if (!el.hidden) el.hidden = true;
      return;
    }
    var span = el.querySelector('[data-bib-mbw-missing]');
    var text = euro.format(state.missing / 100);
    if (span && span.textContent !== text) span.textContent = text;
    if (el.hidden) el.hidden = false;
  }

  function check() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var pendingWelcome = codes.some(function (c) {
          return c && PREFIX.test(String(c.code || '')) && c.applicable === false;
        });
        var sub = Number(cart.items_subtotal_price) || 0;
        state = {
          show: pendingWelcome && sub > 0 && sub < THRESHOLD,
          missing: Math.max(0, THRESHOLD - sub)
        };
        paint();
      })
      .catch(function () {
        state = { show: false, missing: 0 };
        paint();
      });
  }

  var timer = null;
  function checkSoon() {
    clearTimeout(timer);
    timer = setTimeout(check, 400);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      /* Neu malen, wenn der Swap-Bereich ersetzt wurde; pruefen, wenn der
         Drawer aufgeht (Dawn setzt dann die Klasse "active"). */
      new MutationObserver(function (muts) {
        var opened = muts.some(function (m) {
          return m.type === 'attributes' && drawer.classList.contains('active');
        });
        if (opened) checkSoon(); else paint();
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, checkSoon);
    }

    /* Jeder erfolgreiche Cart-Request (auch aus anderen Skripten) loest
       eine Pruefung aus - dieselbe Rueckfallebene wie in biberna-bundle.js. */
    var orig = window.fetch;
    if (typeof orig === 'function') {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url);
        var p = orig.apply(this, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function (res) { if (res && res.ok) checkSoon(); }).catch(function () {});
        }
        return p;
      };
    }

    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
